<template>
  <div class="m-map">
    <div id="myMap"></div>
  </div>
</template>

<script>
import mapBase from "@/mixins/Nodes/map.js";
export default {
  mixins: [mapBase]
};
</script>

<style lang="scss" scoped>
.m-map {
  #myMap {
    height: 46.6vw;
  }
}
</style>

